import axios from "../utils/axios";

export const loginLocal = async (pData) => await axios.post('auth/local', pData)
export const loginGoogle = async (pData) => await axios.post('auth/google', pData)
export const logout = async (pData) => await axios.post('auth/logout', pData) 